export function groupJournalEntriesByMonth(entries) {
  const grouped = new Map();
  const sortedEntries = [...entries].sort((a, b) => String(b.entry_date).localeCompare(String(a.entry_date)));

  for (const entry of sortedEntries) {
    const month = String(entry.entry_date || "").slice(0, 7);
    if (!/^\d{4}-\d{2}$/.test(month)) continue;
    if (!grouped.has(month)) grouped.set(month, []);
    grouped.get(month).push(entry);
  }

  return [...grouped.entries()]
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([month, monthEntries]) => ({
      month,
      label: new Intl.DateTimeFormat("en", { month: "long", year: "numeric", timeZone: "UTC" })
        .format(new Date(`${month}-01T00:00:00Z`)),
      entries: monthEntries,
    }));
}
